export default __webpack_public_path__ + "static/media/kaahu.9bd39316.mp3";